import React from 'react';
import './style.css';
import { Chart } from "react-google-charts";


// export const data = [
//   ["Orders", "Count"],
//   ["New Order", 33],
//   ["Completed Order", 36],
//   ["Return Order", 22],
 
// ];
  export const options = {
    title: "",
    curveType: "function",
    pieSliceText : 'value',
    is3D: true,
    sliceVisibilityThreshold: 0,
    legend: { position: "bottom" },
    colors: ['#FFBF00', '#008000','#BFBF00' ,'#EE4B2B']

  };

 const ReportCard=({chartData,total})=>{
    return <div className='col-xxl-4 col-md-6'>
        <div class="graph-card ">
        <div class="card-body">
        <h5 class="card-title">{'Total Orders ('+total+')'} <span>| {'Order history'}</span></h5>
        <Chart
      chartType="PieChart"
      data={chartData}
      options={options}
      width={"100%"}
      height={"400px"}
    />
    </div>
      
    </div>
    </div>
}
export default ReportCard